<template>
  <div>
    <div class="google-slide-tutorial" :style="{ 'background-image': 'url(' + backgroundImage + ')' }">
      <aha-logo
        width="156"
        height="26"
        viewBox="0 0 9600 1602"
        class="block m-auto lg:ml-3.5"
      />
      <p>
        {{ $i18nPresenter.t('Add live word clouds, polls, quizzes and more directly to Google Slides.') }}
      </p>
      <a
        href="https://help.ahaslides.com/portal/en/kb/articles/using-the-ahaslides-add-on-in-google-slides"
        class="text-primary-90 cursor-pointer fold-bold"
        target="_blank"
      ><h3>{{ $i18nPresenter.t('Click to see how') }}</h3></a>
    </div>
    <h3>{{ $i18nPresenter.t('Create a new slide') }}</h3>
  </div>
</template>

<script>
const backgroundImage = require('@/assets/images/google-slides/tutorial-banner.svg')

export default {
  components: {
  },
  data() {
    return {
      backgroundImage,
    }
  },
  computed: {
  },
}
</script>

<style lang="scss" scoped>
.google-slide-tutorial {
  position: relative;
  padding: 8px;
  padding-top: 16px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  aha-logo {
    margin-bottom: 16px;
    display: block;
  }
  p {
    margin-top: 16px;
    margin-bottom: 16px;
    width: 60%;
  }

  a {
    display: inline-block;
    margin-bottom: 8px;
    font-weight: bold;
  }
}

h3 {
  margin: 12px 8px 0 8px;
}
</style>
